import { Box, Divider, makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  banner: {
    width: '100%',
    background: theme.palette.dark['600'],
    height: 311,
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    background: theme.palette.dark[600],
    borderRadius: theme.shape.borderRadius,
    width: 500,
    height: 32,
  },
  category: {
    background: theme.palette.dark[600],
    borderRadius: theme.shape.borderRadius,
    width: 100,
    height: 16,
  },
  description: {
    background: theme.palette.dark[600],
    borderRadius: theme.shape.borderRadius,
    width: '85%',
    height: 20,
    marginTop: theme.spacing(3),
    '&:nth-child(2)': {
      width: '55%',
    },
    '&:nth-child(3)': {
      width: '75%',
    },
    '&:nth-child(4)': {
      width: '45%',
    },
  },
  avatar: {
    background: theme.palette.dark[600],
    width: 40,
    height: 40,
    borderRadius: 40,
  },
  username: {
    background: theme.palette.dark[600],
    borderRadius: theme.shape.borderRadius,
    width: 145,
    height: 20,
  },
  divider: {
    background: theme.palette.grey[600],
    margin: theme.spacing(4, -6),
  },
}));

const CourseSkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Skeleton className={classes.banner} variant='rect' animation='wave' />

      <Box padding={6}>
        <Skeleton className={classes.title} variant='rect' animation='wave' />
        <Box marginTop={4}>
          <Skeleton className={classes.category} variant='rect' animation='wave' />
        </Box>

        <Divider className={classes.divider} />

        <Box>
          <Skeleton className={classes.description} variant='rect' animation='wave' />
          <Skeleton className={classes.description} variant='rect' animation='wave' />
          <Skeleton className={classes.description} variant='rect' animation='wave' />
          <Skeleton className={classes.description} variant='rect' animation='wave' />
        </Box>

        <Box marginTop={4} display='flex' flexDirection='row' alignItems='center'>
          <Skeleton className={classes.avatar} variant='rect' animation='wave' />
          <Box marginLeft={3}>
            <Skeleton className={classes.username} variant='rect' animation='wave' />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default CourseSkeleton;
